import Navbar from '@/pages/home/components/Navbar';
import Footer from '@/pages/home/components/Footer';
import { useNavigate } from 'react-router-dom';

export default function About() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-background-50 text-foreground-900">
      <Navbar />
      <main>
        <section className="relative py-20 md:py-24 bg-background-50">
          <div className="max-w-3xl mx-auto px-6 md:px-10">
            <button
              type="button"
              onClick={() => navigate('/')}
              className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-background-100 hover:bg-background-200 text-sm font-medium text-foreground-600 transition-colors cursor-pointer whitespace-nowrap mb-10"
            >
              <i className="ri-arrow-left-line"></i>
              返回主頁
            </button>

            {/* Header */}
            <div className="mb-12">
              <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-primary-100/80 text-primary-800 text-xs font-semibold tracking-widest uppercase mb-6 whitespace-nowrap">
                <i className="ri-information-line"></i>
                About Us · 關於我哋
              </div>
              <h1 className="font-heading text-3xl md:text-5xl font-medium text-foreground-950 leading-tight">
                關於 1mindlab<span className="text-primary-500">．</span>關於我哋
              </h1>
            </div>

            {/* Content - Cantonese healing style */}
            <div className="space-y-6 text-sm md:text-base text-foreground-700 leading-8">
              <p>
                喺呢個資訊氾濫、節奏急到抖唔到氣嘅城市，我哋每日好似停唔落嚟咁，不知不覺累積咗一身疲累。
              </p>

              <p>
                <strong className="font-semibold text-foreground-900">1mindlab</strong> 創立嘅初心，就係想為每一個香港人，喺喧鬧之中開闢一個可以俾心靈抖吓氣嘅溫暖角落。我哋好想推廣「抱樹文化」，等呢個同大自然連結嘅簡單習慣，可以喺香港普及起來。
              </p>

              <div className="my-10 flex items-center justify-center">
                <div className="w-16 h-px bg-primary-300/50"></div>
                <div className="mx-4 w-2 h-2 rounded-full bg-primary-400/50"></div>
                <div className="w-16 h-px bg-primary-300/50"></div>
              </div>

              <p>
                其實，大自然嘅療癒力量，遠遠唔止抱樹咁簡單。
              </p>

              <p>
                生活，本來就可以好簡單。去沙灘踩吓沙、感受吓沙粒嘅溫度；喺合適嘅時間曬下太陽、吸吓正能量；或者咩都唔諗，純粹聽吓海浪聲……
              </p>

              <p>
                我哋真心希望，日忙夜忙嘅香港人，都可以有空間、有能力將自己嘅步伐慢落嚟。俾身體同大自然好好接觸，留返個空間，重新去感受返生活。
              </p>

              <div className="my-10 flex items-center justify-center">
                <div className="w-16 h-px bg-primary-300/50"></div>
                <div className="mx-4 w-2 h-2 rounded-full bg-primary-400/50"></div>
                <div className="w-16 h-px bg-primary-300/50"></div>
              </div>

              <p>
                除咗呢個網站，我哋亦希望透過{' '}
                <a
                  href="https://instagram.com/1mindlab"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="font-semibold text-primary-600 hover:text-primary-700 underline decoration-primary-300 underline-offset-4 transition-colors cursor-pointer"
                >
                  Instagram (@1mindlab)
                </a>
                ，同大家分享一啲生活上嘅細微啟發（Insight）。喺一切從簡嘅溫和節奏入面，為自己嘅心靈彈出多一啲空間，去搵返最舒服、最適合自己嘅生活步調。
              </p>
            </div>

            {/* Decorative line at the end */}
            <div className="mt-12 flex items-center justify-center">
              <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg" className="text-primary-300/40">
                <circle cx="20" cy="20" r="18" stroke="currentColor" strokeWidth="0.8" fill="none" />
                <circle cx="20" cy="20" r="8" stroke="currentColor" strokeWidth="0.5" fill="none" />
              </svg>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}